let attempts = 0;
const maxAttempts = 300;


const interval = setInterval(() => {

    attempts++;

    const researchKeyFocus = document.getElementById("research_key_focus");

    // Stop checking once element is found
    if (researchKeyFocus) {

        clearInterval(interval);
        console.log("interval cleared")
        let domain = window.location.origin;
        let url = domain + "/api/v1/json/taxonomy/keyfocus/research";

        fetch(url)
            .then(response => {

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                return response.json();

            })
            .then(data => {

                let wrapper = researchKeyFocus.querySelector(".row-wrapper");

                if (!wrapper) {
                    console.log("Wrapper element not found");
                    return;
                }

                let html = '';

                data.forEach((item, index) => {

                    html += `
                        <div class="col-three wow fadeInUp" data-wow-delay="0.${index + 1}s">

                            ${item.field_edit_link ? `
                                <a class="node-edit" href="${item.field_edit_link}">
                                    [edit]
                                </a>
                            ` : ''}

                            ${item.field_link ? `
                                <a href="${item.field_link}">.</a>
                            ` : ''}

                            <div class="bg-img">

                                ${item.field_featured_image_src ? `
                                    <img 
                                        src="${item.field_featured_image_src}" 
                                        alt="${item.field_featured_image_alt || ''}"
                                    >
                                ` : ''}

                            </div>

                            ${item.field_title ? `
                                <h4>${item.field_title.replace(/&amp;/g, '&')}</h4>
                            ` : ''}

                        </div>
                    `;
                });

                wrapper.innerHTML = html;

            })
            .catch(error => {

                console.log("Error:", error);

            });
    }

    // Stop interval after max attempts
    if (attempts >= maxAttempts) {

        clearInterval(interval);

        // console.log("research_key_focus element not found after 300 attempts.");

    }

}, 100);